import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { updateOrg as updateOrgAPI} from 'services/apiOrg';

const useEditOrg = () => {
  const queryClient = useQueryClient();
  const{isPending: isEditing, isSuccess: isEdited, mutate: updateOrg} = useMutation({
    mutationFn: updateOrgAPI,
    onSuccess:(data)=>{
        queryClient.setQueryData(['updatedOrg'],data)
        toast.success('Updated Successfully')
        queryClient.invalidateQueries({queryKey:['orgList']})
    },
    onError:(error)=>{
        console.log("Error occurred when Updating the Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isEditing, isEdited, updateOrg}
}

export default useEditOrg